import * as React from 'react';
import { SVGProps } from 'react';

const SvgFire = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.67723 7.41076C8.69576 4.62508 5.2012 4.47487 6.04514 0.426077C6.10766 0.12566 5.81384 -0.106479 5.57629 0.0505564C3.30701 1.51167 1.67539 4.44073 3.04445 8.27787C3.15698 8.59194 2.8194 8.88553 2.57559 8.6807C1.44408 7.74531 1.32531 6.40026 1.42533 5.43757C1.46284 5.08253 1.03774 4.91184 0.856448 5.20543C0.431349 5.9155 0 7.06255 0 8.78994C0.237555 12.6134 3.19449 13.7878 4.25723 13.938C5.77633 14.1496 7.42046 13.8424 8.60199 12.6612C9.90229 11.3435 10.3774 9.24057 9.67723 7.41076Z"
      fill="#E93D44"
    />
  </svg>
);

export default SvgFire;
